import { render } from "./opCurrency.vue?vue&type=template&id=be58f616&ts=true"
import script from "./opCurrency.vue?vue&type=script&lang=ts"
export * from "./opCurrency.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__